var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-container",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
    },
    [
      _c(
        "el-container",
        [
          _c(
            "el-header",
            { attrs: { height: "42px" } },
            [
              _vm.viewMode == "list"
                ? _c("span", { staticClass: "ik-list-title" }, [
                    _c(
                      "span",
                      { staticClass: "svg-container ik-list-icon" },
                      [_c("svg-icon", { attrs: { "icon-class": "database" } })],
                      1
                    ),
                    _c("span", [_vm._v("数据列表")]),
                  ])
                : _vm._e(),
              _vm.viewMode === "list"
                ? _c(
                    "el-button-group",
                    { staticClass: "ik-list-menu" },
                    [
                      _vm.activeRow.payStateSign == 1
                        ? _c(
                            "el-button",
                            {
                              staticClass: "ik-list-menu-btn",
                              attrs: { size: "medium" },
                              on: { click: _vm.listDetailsBtn },
                            },
                            [_vm._v("详情")]
                          )
                        : _vm._e(),
                      _vm.activeRow.payStateSign == 1
                        ? _c(
                            "el-button",
                            {
                              staticClass: "ik-list-menu-btn",
                              attrs: { size: "medium" },
                              on: { click: _vm.listPrintShow },
                            },
                            [_vm._v("打印")]
                          )
                        : _vm._e(),
                      _c(
                        "el-button",
                        {
                          staticClass: "ik-list-menu-btn",
                          attrs: { size: "medium" },
                          on: { click: _vm.listDeleteBtn },
                        },
                        [_vm._v("删除")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.viewMode === "info"
                ? _c(
                    "el-button-group",
                    { staticClass: "ik-list-menu" },
                    [
                      _vm.mode == "edit"
                        ? _c(
                            "el-button",
                            {
                              staticClass: "ik-list-menu-btn",
                              attrs: { size: "medium" },
                              on: { click: _vm.infoDetailsBtn },
                            },
                            [_vm._v("详情")]
                          )
                        : _vm._e(),
                      _vm.mode == "add" || _vm.mode == "edit"
                        ? _c(
                            "el-button",
                            {
                              staticClass: "ik-list-menu-btn",
                              attrs: { size: "medium" },
                              on: { click: _vm.infoSaveBtn },
                            },
                            [_vm._v("保存")]
                          )
                        : _vm._e(),
                      _vm.mode == "edit" || _vm.mode == "details"
                        ? _c(
                            "el-button",
                            {
                              staticClass: "ik-list-menu-btn",
                              attrs: { size: "medium" },
                              on: { click: _vm.printShow },
                            },
                            [_vm._v("打印")]
                          )
                        : _vm._e(),
                      _c(
                        "el-button",
                        {
                          staticClass: "ik-list-menu-btn",
                          attrs: { size: "medium" },
                          on: { click: _vm.infoCancelBtn },
                        },
                        [_vm._v("取消")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "el-main",
            [
              _vm.viewMode == "info"
                ? _c(
                    "el-form",
                    {
                      staticClass: "ik-info-head",
                      attrs: {
                        id: "ik-info-head",
                        inline: true,
                        "label-width": "120px",
                        disabled: _vm.mode == "details",
                      },
                      on: { validate: _vm.validate },
                      model: {
                        value: _vm.data.head,
                        callback: function ($$v) {
                          _vm.$set(_vm.data, "head", $$v)
                        },
                        expression: "data.head",
                      },
                    },
                    [
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-text", {
                                ref: "input_code",
                                attrs: {
                                  code: "code",
                                  name: "编码",
                                  "default-value": "",
                                  require: true,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["code"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "code", $$v)
                                  },
                                  expression: "data.head['code']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-text", {
                                ref: "input_name",
                                attrs: {
                                  code: "name",
                                  name: "名称",
                                  "default-value": "",
                                  require: true,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["name"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "name", $$v)
                                  },
                                  expression: "data.head['name']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-data-popup", {
                                ref: "input_userCode",
                                attrs: {
                                  code: "userCode",
                                  name: "用户编码",
                                  url: "base/user/user/user/find/findPagination",
                                  require: true,
                                  "filed-list": [
                                    { code: "id", name: "ID" },
                                    { code: "code", name: "编码" },
                                    { code: "name", name: "名称" },
                                  ],
                                  "search-key": "name",
                                  searcher: {},
                                  "default-value": "",
                                  "min-length": 0,
                                  "max-length": 20,
                                  disabled: false,
                                },
                                on: { onPopupClick: _vm.searchPopupClick },
                                model: {
                                  value: _vm.data.head["userCode"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "userCode", $$v)
                                  },
                                  expression: "data.head['userCode']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-text", {
                                ref: "input_userName",
                                attrs: {
                                  code: "userName",
                                  name: "用户名称",
                                  "default-value": "",
                                  require: true,
                                  disabled: true,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["userName"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "userName", $$v)
                                  },
                                  expression: "data.head['userName']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-data-popup", {
                                ref: "input_robotCode",
                                attrs: {
                                  code: "robotCode",
                                  name: "机器人编码",
                                  url: "base/user/robot/robot/find/findPagination",
                                  require: true,
                                  "filed-list": [
                                    { code: "code", name: "编码" },
                                    { code: "name", name: "名称" },
                                  ],
                                  "search-key": "name",
                                  searcher: {},
                                  "default-value": "",
                                  "min-length": 0,
                                  "max-length": 20,
                                  disabled: false,
                                },
                                on: { onPopupClick: _vm.searchPopupClick },
                                model: {
                                  value: _vm.data.head["robotCode"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "robotCode", $$v)
                                  },
                                  expression: "data.head['robotCode']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-text", {
                                ref: "input_robotName",
                                attrs: {
                                  code: "robotName",
                                  name: "机器人名称",
                                  "default-value": "",
                                  require: false,
                                  disabled: true,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["robotName"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "robotName", $$v)
                                  },
                                  expression: "data.head['robotName']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-select", {
                                ref: "input_stateSign",
                                attrs: {
                                  code: "stateSign",
                                  name: "报告状态标识",
                                  "default-value": "",
                                  "key-field": "key",
                                  "value-field": "value",
                                  options: _vm.toJson(_vm.jsonStr.stateSign),
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["stateSign"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "stateSign", $$v)
                                  },
                                  expression: "data.head['stateSign']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-datetime", {
                                ref: "input_diagTime",
                                attrs: {
                                  code: "diagTime",
                                  name: "诊断时间",
                                  "default-value": "",
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["diagTime"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "diagTime", $$v)
                                  },
                                  expression: "data.head['diagTime']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-data-popup", {
                                ref: "input_storeCode",
                                attrs: {
                                  url: "base/user/user/store/find/findPagination",
                                  "filed-list": [
                                    { code: "code", name: "编码" },
                                    { code: "name", name: "名称" },
                                  ],
                                  "search-key": "name",
                                  searcher: {},
                                  code: "storeCode",
                                  name: "门店编码",
                                  "default-value": "",
                                  "min-length": 0,
                                  "max-length": 20,
                                  disabled: false,
                                  require: true,
                                },
                                on: {
                                  onFieldChange: _vm.onFieldChange,
                                  onPopupClick: _vm.headPopupClick,
                                },
                                model: {
                                  value: _vm.data.head["storeCode"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "storeCode", $$v)
                                  },
                                  expression: "data.head['storeCode']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-text", {
                                ref: "input_storeName",
                                attrs: {
                                  code: "storeName",
                                  name: "门店名称",
                                  "default-value": "",
                                  "min-length": 0,
                                  "max-length": 20,
                                  disabled: true,
                                  require: true,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["storeName"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "storeName", $$v)
                                  },
                                  expression: "data.head['storeName']",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.mode == "edit" || _vm.mode == "details"
                        ? _c(
                            "el-tabs",
                            {
                              staticStyle: { margin: "0 10px" },
                              model: {
                                value: _vm.active,
                                callback: function ($$v) {
                                  _vm.active = $$v
                                },
                                expression: "active",
                              },
                            },
                            [
                              _c(
                                "el-tab-pane",
                                { attrs: { label: "体质", name: "1" } },
                                [
                                  _c("div", [
                                    _c("div", { staticClass: "mainPhy" }, [
                                      _c("div", [
                                        _vm.data.head.mainPhyCode
                                          ? _c("img", {
                                              attrs: {
                                                src: require(`@/assets/health/${_vm.data.head.mainPhyCode}.png`),
                                                alt: "",
                                              },
                                            })
                                          : _vm._e(),
                                      ]),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            flex: "1",
                                            display: "flex",
                                            "justify-content": "center",
                                            "align-items": "center",
                                            "flex-direction": "column",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.data.head.mainPhyName
                                              ) +
                                              " "
                                          ),
                                          _c("div", [
                                            _vm._v(
                                              " 程度：" +
                                                _vm._s(
                                                  _vm.data.head.mainPhyPct
                                                ) +
                                                "% "
                                            ),
                                          ]),
                                        ]
                                      ),
                                      _c("div", [
                                        _c("img", {
                                          attrs: {
                                            src: require("@/assets/icon/zhutizhi.png"),
                                            alt: "",
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ]),
                                  _c("div", [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          display: "flex",
                                          "flex-wrap": "wrap",
                                        },
                                      },
                                      [
                                        _vm._l(8, function (item, index) {
                                          return [
                                            _vm.data.head["phy" + item + "Name"]
                                              ? _c(
                                                  "div",
                                                  {
                                                    key: index,
                                                    staticClass: "mainPhy",
                                                    staticStyle: {
                                                      margin: "10px 0",
                                                      "margin-right": "10px",
                                                    },
                                                  },
                                                  [
                                                    _c("img", {
                                                      attrs: {
                                                        src: require(`@/assets/health/${
                                                          _vm.data.head[
                                                            "phy" +
                                                              item +
                                                              "Code"
                                                          ]
                                                        }.png`),
                                                        alt: "",
                                                      },
                                                    }),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticStyle: {
                                                          flex: "1",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.data.head[
                                                                "phy" +
                                                                  item +
                                                                  "Name"
                                                              ]
                                                            ) +
                                                            " "
                                                        ),
                                                        _c("div", [
                                                          _vm._v(
                                                            " 程度：" +
                                                              _vm._s(
                                                                _vm.data.head[
                                                                  "phyPct" +
                                                                    item
                                                                ]
                                                              ) +
                                                              "% "
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                    _c("div", [
                                                      _c("img", {
                                                        attrs: {
                                                          src: require("@/assets/icon/futizhi.png"),
                                                          alt: "",
                                                        },
                                                      }),
                                                    ]),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        }),
                                      ],
                                      2
                                    ),
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        margin: "20px 0",
                                      },
                                    },
                                    [
                                      _c("div", {
                                        staticStyle: {
                                          "border-left":
                                            "5px solid rgb(22, 93, 255)",
                                          padding: "0 0 10px 10px",
                                        },
                                      }),
                                      _c("div", [_vm._v(" 方案 ")]),
                                    ]
                                  ),
                                  _c("div", {
                                    staticStyle: { "text-align": "start" },
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.schemeHtml.head.htmlContent
                                      ),
                                    },
                                  }),
                                ]
                              ),
                              _c(
                                "el-tab-pane",
                                { attrs: { label: "面诊", name: "2" } },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        margin: "10px 0",
                                        "text-align": "start",
                                      },
                                    },
                                    [
                                      _c("img", {
                                        staticStyle: { height: "200px" },
                                        attrs: {
                                          src: _vm.getsrc(
                                            _vm.data.head.faceImg
                                          ),
                                          alt: "",
                                        },
                                      }),
                                    ]
                                  ),
                                  _c("div", [
                                    _c(
                                      "div",
                                      { staticStyle: { display: "flex" } },
                                      [
                                        _c("div", { staticClass: "formItem" }, [
                                          _vm._v(" 指标 "),
                                        ]),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "formItem",
                                            staticStyle: { width: "300px" },
                                          },
                                          [_vm._v(" 说明 ")]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "formItem",
                                            staticStyle: { width: "450px" },
                                          },
                                          [_vm._v(" 解释 ")]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticStyle: { display: "flex" } },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "formItem",
                                            staticStyle: { background: "#fff" },
                                          },
                                          [_vm._v(" 面部颜色 ")]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "formItem",
                                            staticStyle: {
                                              width: "300px",
                                              background: "#fff",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.getOptions(
                                                    "faceColorSign",
                                                    _vm.data.head.faceColorSign
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "formItem",
                                            staticStyle: {
                                              width: "450px",
                                              background: "#fff",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.getText(
                                                    _vm.getOptions(
                                                      "faceColorSign",
                                                      _vm.data.head
                                                        .faceColorSign
                                                    )
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticStyle: { display: "flex" } },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "formItem",
                                            staticStyle: { background: "#fff" },
                                          },
                                          [_vm._v(" 面部色泽 ")]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "formItem",
                                            staticStyle: {
                                              width: "300px",
                                              background: "#fff",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.getOptions(
                                                    "faceLustreSign",
                                                    _vm.data.head.faceLustreSign
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "formItem",
                                            staticStyle: {
                                              width: "450px",
                                              background: "#fff",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.getOptions(
                                                    "faceLustreSign",
                                                    _vm.data.head.faceLustreSign
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticStyle: { display: "flex" } },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "formItem",
                                            staticStyle: { background: "#fff" },
                                          },
                                          [_vm._v(" 嘴唇检测 ")]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "formItem",
                                            staticStyle: {
                                              width: "300px",
                                              background: "#fff",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.getOptions(
                                                    "lipRecognitionSign",
                                                    _vm.data.head
                                                      .lipRecognitionSign
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c("div", {
                                          staticClass: "formItem",
                                          staticStyle: {
                                            width: "450px",
                                            background: "#fff",
                                          },
                                        }),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticStyle: { display: "flex" } },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "formItem",
                                            staticStyle: { background: "#fff" },
                                          },
                                          [_vm._v(" 嘴唇 ")]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "formItem",
                                            staticStyle: {
                                              width: "300px",
                                              background: "#fff",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.getOptions(
                                                    "lipColorSign",
                                                    _vm.data.head.lipColorSign
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "formItem",
                                            staticStyle: {
                                              width: "450px",
                                              background: "#fff",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.getText(
                                                    _vm.getOptions(
                                                      "lipColorSign",
                                                      _vm.data.head.lipColorSign
                                                    )
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]
                              ),
                              _c(
                                "el-tab-pane",
                                { attrs: { label: "舌诊", name: "3" } },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        margin: "10px 0",
                                        "text-align": "start",
                                      },
                                    },
                                    [
                                      _c("img", {
                                        staticStyle: { height: "200px" },
                                        attrs: {
                                          src: _vm.getsrc(
                                            _vm.data.head.tongueImg
                                          ),
                                          alt: "",
                                        },
                                      }),
                                    ]
                                  ),
                                  _c("div", [
                                    _c(
                                      "div",
                                      { staticStyle: { display: "flex" } },
                                      [
                                        _c("div", { staticClass: "formItem" }, [
                                          _vm._v(" 指标 "),
                                        ]),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "formItem",
                                            staticStyle: { width: "300px" },
                                          },
                                          [_vm._v(" 说明 ")]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "formItem",
                                            staticStyle: { width: "450px" },
                                          },
                                          [_vm._v(" 解释 ")]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticStyle: { display: "flex" } },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "formItem",
                                            staticStyle: { background: "#fff" },
                                          },
                                          [_vm._v(" 舌裂纹检测 ")]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "formItem",
                                            staticStyle: {
                                              width: "300px",
                                              background: "#fff",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.getOptions(
                                                    "tongueCrackSign",
                                                    _vm.data.head
                                                      .tongueCrackSign
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "formItem",
                                            staticStyle: {
                                              width: "450px",
                                              background: "#fff",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.data.head
                                                    .tongueCrackSign == "1"
                                                    ? "纵向/横向沟裂 阴液枯涸 阴虚/危候"
                                                    : ""
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticStyle: { display: "flex" } },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "formItem",
                                            staticStyle: { background: "#fff" },
                                          },
                                          [_vm._v(" 舌胖瘦检测 ")]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "formItem",
                                            staticStyle: {
                                              width: "300px",
                                              background: "#fff",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.getOptions(
                                                    "tongueCoatThickSign",
                                                    _vm.data.head
                                                      .tongueCoatThickSign
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "formItem",
                                            staticStyle: {
                                              width: "450px",
                                              background: "#fff",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.data.head
                                                    .tongueCoatThickSign == "0"
                                                    ? "舌体薄小 气血双亏 实证"
                                                    : "舌体肿胀 水湿内停 虚证"
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticStyle: { display: "flex" } },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "formItem",
                                            staticStyle: { background: "#fff" },
                                          },
                                          [_vm._v(" 舌苔厚薄检测 ")]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "formItem",
                                            staticStyle: {
                                              width: "300px",
                                              background: "#fff",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.getOptions(
                                                    "tongueFatSign",
                                                    _vm.data.head.tongueFatSign
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "formItem",
                                            staticStyle: {
                                              width: "450px",
                                              background: "#fff",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.data.head.tongueFatSign ==
                                                    "0"
                                                    ? ""
                                                    : "厚苔苔质致密难见舌质​ 里证/重证​：痰湿食积内停 慢性胃炎、慢阻肺、痰饮证"
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticStyle: { display: "flex" } },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "formItem",
                                            staticStyle: { background: "#fff" },
                                          },
                                          [_vm._v(" 舌苔颜色检测 ")]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "formItem",
                                            staticStyle: {
                                              width: "300px",
                                              background: "#fff",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.getOptions(
                                                    "tongueCoatColorSign",
                                                    _vm.data.head
                                                      .tongueCoatColorSign
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c("div", {
                                          staticClass: "formItem",
                                          staticStyle: {
                                            width: "450px",
                                            background: "#fff",
                                          },
                                        }),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticStyle: { display: "flex" } },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "formItem",
                                            staticStyle: { background: "#fff" },
                                          },
                                          [_vm._v(" 舌质颜色检测 ")]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "formItem",
                                            staticStyle: {
                                              width: "300px",
                                              background: "#fff",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.getOptions(
                                                    "tongueColorSign",
                                                    _vm.data.head
                                                      .tongueColorSign
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c("div", {
                                          staticClass: "formItem",
                                          staticStyle: {
                                            width: "450px",
                                            background: "#fff",
                                          },
                                        }),
                                      ]
                                    ),
                                  ]),
                                ]
                              ),
                              _c(
                                "el-tab-pane",
                                { attrs: { label: "问诊", name: "4" } },
                                [
                                  _c(
                                    "div",
                                    { staticStyle: { margin: "10px" } },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "align-items": "center",
                                          },
                                        },
                                        [
                                          _c("img", {
                                            staticStyle: {
                                              "margin-right": "8px",
                                            },
                                            attrs: {
                                              src: require("@/assets/icon/qa.png"),
                                              alt: "",
                                            },
                                          }),
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                color: "rgb(24, 204, 145)",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "您自己觉得容易疲劳或乏力吗？"
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            margin: "20px 0",
                                            "border-bottom": "1px solid #ccc",
                                            color: "rgba(86, 87, 93, 0.64)",
                                            "text-align": "start",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " 食少、腹胀、便溏、大腹便便、面色偏暗、无光泽、经常犯困、疲乏嗜睡、舌淡胖、苔白腻、舌边上还有齿痕印、脉濡缓等。 "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                { staticClass: "querybg" },
                [
                  _vm.viewMode == "list"
                    ? _c(
                        "el-collapse",
                        {
                          staticClass: "ik-list-searcher",
                          attrs: { accordion: "" },
                          model: {
                            value: _vm.searcherActive,
                            callback: function ($$v) {
                              _vm.searcherActive = $$v
                            },
                            expression: "searcherActive",
                          },
                        },
                        [
                          _c(
                            "el-collapse-item",
                            {
                              staticClass: "ik-list-searcher-item",
                              attrs: { title: "", name: "1" },
                            },
                            [
                              _c("template", { slot: "title" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "ik-list-searcher-item-titles",
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "svg-container ik-list-icon",
                                      },
                                      [
                                        _c("svg-icon", {
                                          attrs: { "icon-class": "search" },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" 查询条件 "),
                                  ]
                                ),
                              ]),
                              _c(
                                "el-form",
                                {
                                  staticClass: "ik-info-head",
                                  attrs: {
                                    id: "ik-info-head",
                                    inline: true,
                                    "label-width": "120px",
                                    disabled: false,
                                  },
                                  model: {
                                    value: _vm.searcher,
                                    callback: function ($$v) {
                                      _vm.searcher = $$v
                                    },
                                    expression: "searcher",
                                  },
                                },
                                [
                                  _c(
                                    "el-row",
                                    [
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-text", {
                                            ref: "input_code",
                                            attrs: {
                                              code: "code",
                                              name: "编码",
                                              disabled: false,
                                            },
                                            model: {
                                              value: _vm.searcher["code"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "code",
                                                  $$v
                                                )
                                              },
                                              expression: "searcher['code']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-text", {
                                            ref: "input_name",
                                            attrs: {
                                              code: "name",
                                              name: "名称",
                                              disabled: false,
                                            },
                                            model: {
                                              value: _vm.searcher["name"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "name",
                                                  $$v
                                                )
                                              },
                                              expression: "searcher['name']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-text", {
                                            ref: "input_userCode",
                                            attrs: {
                                              code: "userCode",
                                              name: "用户编码",
                                              disabled: false,
                                            },
                                            model: {
                                              value: _vm.searcher["userCode"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "userCode",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['userCode']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-text", {
                                            ref: "input_userName",
                                            attrs: {
                                              code: "userName",
                                              name: "用户名称",
                                              disabled: false,
                                            },
                                            model: {
                                              value: _vm.searcher["userName"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "userName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['userName']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-text", {
                                            ref: "input_robotCode",
                                            attrs: {
                                              code: "robotCode",
                                              name: "机器人编码",
                                              disabled: false,
                                            },
                                            model: {
                                              value: _vm.searcher["robotCode"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "robotCode",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['robotCode']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-text", {
                                            ref: "input_robotName",
                                            attrs: {
                                              code: "robotName",
                                              name: "机器人名称",
                                              disabled: false,
                                            },
                                            model: {
                                              value: _vm.searcher["robotName"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "robotName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['robotName']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-select", {
                                            ref: "input_stateSign",
                                            attrs: {
                                              code: "stateSign",
                                              name: "机器人名称",
                                              disabled: false,
                                              "key-field": "key",
                                              "value-field": "value",
                                              options: _vm.toJson(
                                                _vm.jsonStr.stateSign
                                              ),
                                            },
                                            on: {
                                              onFieldChange: _vm.onFieldChange,
                                            },
                                            model: {
                                              value: _vm.searcher["stateSign"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "stateSign",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['stateSign']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-datetime", {
                                            ref: "input_minDiagTime",
                                            attrs: {
                                              code: "minDiagTime",
                                              name: "最早诊断时间",
                                              disabled: false,
                                            },
                                            model: {
                                              value:
                                                _vm.searcher["minDiagTime"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "minDiagTime",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['minDiagTime']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-datetime", {
                                            ref: "input_maxDiagTime",
                                            attrs: {
                                              code: "maxDiagTime",
                                              name: "最晚诊断时间",
                                              disabled: false,
                                            },
                                            model: {
                                              value:
                                                _vm.searcher["maxDiagTime"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "maxDiagTime",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['maxDiagTime']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-text", {
                                            ref: "input_mainPhyCode",
                                            attrs: {
                                              code: "mainPhyCode",
                                              name: "主体质编码",
                                              disabled: false,
                                            },
                                            model: {
                                              value:
                                                _vm.searcher["mainPhyCode"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "mainPhyCode",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['mainPhyCode']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-text", {
                                            ref: "input_mainPhyName",
                                            attrs: {
                                              code: "mainPhyName",
                                              name: "主体质名称",
                                              disabled: false,
                                            },
                                            model: {
                                              value:
                                                _vm.searcher["mainPhyName"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "mainPhyName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['mainPhyName']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-text", {
                                            ref: "input_phyCode1",
                                            attrs: {
                                              code: "phyCode1",
                                              name: "副体质1编码",
                                              disabled: false,
                                            },
                                            model: {
                                              value: _vm.searcher["phyCode1"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "phyCode1",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['phyCode1']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-text", {
                                            ref: "input_phyName1",
                                            attrs: {
                                              code: "phyName1",
                                              name: "副体质1名称",
                                              disabled: false,
                                            },
                                            model: {
                                              value: _vm.searcher["phyName1"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "phyName1",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['phyName1']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-text", {
                                            ref: "input_phyCode2",
                                            attrs: {
                                              code: "phyCode2",
                                              name: "副体质2编码",
                                              disabled: false,
                                            },
                                            model: {
                                              value: _vm.searcher["phyCode2"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "phyCode2",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['phyCode2']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-text", {
                                            ref: "input_phyName2",
                                            attrs: {
                                              code: "phyName2",
                                              name: "副体质2名称",
                                              disabled: false,
                                            },
                                            model: {
                                              value: _vm.searcher["phyName2"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "phyName2",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['phyName2']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-text", {
                                            ref: "input_phyCode3",
                                            attrs: {
                                              code: "phyCode3",
                                              name: "副体质3编码",
                                              disabled: false,
                                            },
                                            model: {
                                              value: _vm.searcher["phyCode3"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "phyCode3",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['phyCode3']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-text", {
                                            ref: "input_phyName3",
                                            attrs: {
                                              code: "phyName3",
                                              name: "副体质3名称",
                                              disabled: false,
                                            },
                                            model: {
                                              value: _vm.searcher["phyName3"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "phyName3",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['phyName3']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-text", {
                                            ref: "input_phyCode4",
                                            attrs: {
                                              code: "phyCode4",
                                              name: "副体质4编码",
                                              disabled: false,
                                            },
                                            model: {
                                              value: _vm.searcher["phyCode4"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "phyCode4",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['phyCode4']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-text", {
                                            ref: "input_phyName4",
                                            attrs: {
                                              code: "phyName4",
                                              name: "副体质4名称",
                                              disabled: false,
                                            },
                                            model: {
                                              value: _vm.searcher["phyName4"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "phyName4",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['phyName4']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-text", {
                                            ref: "input_phyCode5",
                                            attrs: {
                                              code: "phyCode5",
                                              name: "副体质5编码",
                                              disabled: false,
                                            },
                                            model: {
                                              value: _vm.searcher["phyCode5"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "phyCode5",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['phyCode5']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-text", {
                                            ref: "input_phyName5",
                                            attrs: {
                                              code: "phyName5",
                                              name: "副体质5名称",
                                              disabled: false,
                                            },
                                            model: {
                                              value: _vm.searcher["phyName5"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "phyName5",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['phyName5']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-text", {
                                            ref: "input_phyCode6",
                                            attrs: {
                                              code: "phyCode6",
                                              name: "副体质6编码",
                                              disabled: false,
                                            },
                                            model: {
                                              value: _vm.searcher["phyCode6"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "phyCode6",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['phyCode6']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-text", {
                                            ref: "input_phyName6",
                                            attrs: {
                                              code: "phyName6",
                                              name: "副体质6名称",
                                              disabled: false,
                                            },
                                            model: {
                                              value: _vm.searcher["phyName6"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "phyName6",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['phyName6']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-text", {
                                            ref: "input_phyCode7",
                                            attrs: {
                                              code: "phyCode7",
                                              name: "副体质7编码",
                                              disabled: false,
                                            },
                                            model: {
                                              value: _vm.searcher["phyCode7"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "phyCode7",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['phyCode7']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-text", {
                                            ref: "input_phyName7",
                                            attrs: {
                                              code: "phyName7",
                                              name: "副体质7名称",
                                              disabled: false,
                                            },
                                            model: {
                                              value: _vm.searcher["phyName7"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "phyName7",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['phyName7']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-text", {
                                            ref: "input_phyCode8",
                                            attrs: {
                                              code: "phyCode8",
                                              name: "副体质8编码",
                                              disabled: false,
                                            },
                                            model: {
                                              value: _vm.searcher["phyCode8"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "phyCode8",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['phyCode8']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-text", {
                                            ref: "input_phyName8",
                                            attrs: {
                                              code: "phyName8",
                                              name: "副体质8名称",
                                              disabled: false,
                                            },
                                            model: {
                                              value: _vm.searcher["phyName8"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "phyName8",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['phyName8']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-select", {
                                            ref: "input_levelSign",
                                            attrs: {
                                              code: "levelSign",
                                              name: "健康评级标识",
                                              disabled: false,
                                              "key-field": "key",
                                              "value-field": "value",
                                              options: _vm.toJson(
                                                _vm.jsonStr.levelSign
                                              ),
                                            },
                                            on: {
                                              onFieldChange: _vm.onFieldChange,
                                            },
                                            model: {
                                              value: _vm.searcher["levelSign"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "levelSign",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['levelSign']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-select", {
                                            ref: "input_phyDiagSign",
                                            attrs: {
                                              code: "phyDiagSign",
                                              name: "体质诊断标注标识",
                                              disabled: false,
                                              "key-field": "key",
                                              "value-field": "value",
                                              options: _vm.toJson(
                                                _vm.jsonStr.faceDiagSign
                                              ),
                                            },
                                            on: {
                                              onFieldChange: _vm.onFieldChange,
                                            },
                                            model: {
                                              value:
                                                _vm.searcher["phyDiagSign"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "phyDiagSign",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['phyDiagSign']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-text", {
                                            ref: "input_diagPhyCode",
                                            attrs: {
                                              code: "diagPhyCode",
                                              name: "诊断体质编码",
                                              disabled: false,
                                            },
                                            model: {
                                              value:
                                                _vm.searcher["diagPhyCode"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "diagPhyCode",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['diagPhyCode']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-text", {
                                            ref: "input_diagPhyName",
                                            attrs: {
                                              code: "diagPhyName",
                                              name: "诊断体质名称",
                                              disabled: false,
                                            },
                                            model: {
                                              value:
                                                _vm.searcher["diagPhyName"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "diagPhyName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['diagPhyName']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-select", {
                                            ref: "input_diagLevelSign",
                                            attrs: {
                                              code: "diagLevelSign",
                                              name: "诊断健康评级标识",
                                              disabled: false,
                                              "key-field": "key",
                                              "value-field": "value",
                                              options: _vm.toJson(
                                                _vm.jsonStr.levelSign
                                              ),
                                            },
                                            on: {
                                              onFieldChange: _vm.onFieldChange,
                                            },
                                            model: {
                                              value:
                                                _vm.searcher["diagLevelSign"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "diagLevelSign",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['diagLevelSign']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-select", {
                                            ref: "input_faceRecognitionSign",
                                            attrs: {
                                              code: "faceRecognitionSign",
                                              name: "面部检测结果",
                                              disabled: false,
                                              "key-field": "key",
                                              "value-field": "value",
                                              options: _vm.toJson(
                                                _vm.jsonStr.faceRecognitionSign
                                              ),
                                            },
                                            on: {
                                              onFieldChange: _vm.onFieldChange,
                                            },
                                            model: {
                                              value:
                                                _vm.searcher[
                                                  "faceRecognitionSign"
                                                ],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "faceRecognitionSign",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['faceRecognitionSign']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-select", {
                                            ref: "input_faceColorSign",
                                            attrs: {
                                              code: "faceColorSign",
                                              name: "面部颜色结果",
                                              disabled: false,
                                              "key-field": "key",
                                              "value-field": "value",
                                              options: _vm.toJson(
                                                _vm.jsonStr.faceColorSign
                                              ),
                                            },
                                            on: {
                                              onFieldChange: _vm.onFieldChange,
                                            },
                                            model: {
                                              value:
                                                _vm.searcher["faceColorSign"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "faceColorSign",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['faceColorSign']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-select", {
                                            ref: "input_faceLustreSign",
                                            attrs: {
                                              code: "faceColorSign",
                                              name: "面部色泽结果",
                                              disabled: false,
                                              "key-field": "key",
                                              "value-field": "value",
                                              options: _vm.toJson(
                                                _vm.jsonStr.faceLustreSign
                                              ),
                                            },
                                            on: {
                                              onFieldChange: _vm.onFieldChange,
                                            },
                                            model: {
                                              value:
                                                _vm.searcher["faceLustreSign"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "faceLustreSign",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['faceLustreSign']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-select", {
                                            ref: "input_lipRecognitionSign",
                                            attrs: {
                                              code: "lipRecognitionSign",
                                              name: "嘴唇检测结果",
                                              disabled: false,
                                              "key-field": "key",
                                              "value-field": "value",
                                              options: _vm.toJson(
                                                _vm.jsonStr.lipRecognitionSign
                                              ),
                                            },
                                            on: {
                                              onFieldChange: _vm.onFieldChange,
                                            },
                                            model: {
                                              value:
                                                _vm.searcher[
                                                  "lipRecognitionSign"
                                                ],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "lipRecognitionSign",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['lipRecognitionSign']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-select", {
                                            ref: "input_lipColorSign",
                                            attrs: {
                                              code: "lipColorSign",
                                              name: "嘴唇颜色结果",
                                              disabled: false,
                                              "key-field": "key",
                                              "value-field": "value",
                                              options: _vm.toJson(
                                                _vm.jsonStr.lipColorSign
                                              ),
                                            },
                                            on: {
                                              onFieldChange: _vm.onFieldChange,
                                            },
                                            model: {
                                              value:
                                                _vm.searcher["lipColorSign"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "lipColorSign",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['lipColorSign']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-select", {
                                            ref: "input_lipColorSign",
                                            attrs: {
                                              code: "lipColorSign",
                                              name: "嘴唇颜色结果",
                                              disabled: false,
                                              "key-field": "key",
                                              "value-field": "value",
                                              options: _vm.toJson(
                                                _vm.jsonStr.lipColorSign
                                              ),
                                            },
                                            on: {
                                              onFieldChange: _vm.onFieldChange,
                                            },
                                            model: {
                                              value:
                                                _vm.searcher["lipColorSign"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "lipColorSign",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['lipColorSign']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-select", {
                                            ref: "input_faceDiagSign",
                                            attrs: {
                                              code: "faceDiagSign",
                                              name: "面诊诊断标注标识",
                                              disabled: false,
                                              "key-field": "key",
                                              "value-field": "value",
                                              options: _vm.toJson(
                                                _vm.jsonStr.faceDiagSign
                                              ),
                                            },
                                            on: {
                                              onFieldChange: _vm.onFieldChange,
                                            },
                                            model: {
                                              value:
                                                _vm.searcher["faceDiagSign"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "faceDiagSign",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['faceDiagSign']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-select", {
                                            ref: "input_diagFaceColorSign",
                                            attrs: {
                                              code: "diagFaceColorSign",
                                              name: "诊断面部颜色结果",
                                              disabled: false,
                                              "key-field": "key",
                                              "value-field": "value",
                                              options: _vm.toJson(
                                                _vm.jsonStr.faceColorSign
                                              ),
                                            },
                                            on: {
                                              onFieldChange: _vm.onFieldChange,
                                            },
                                            model: {
                                              value:
                                                _vm.searcher[
                                                  "diagFaceColorSign"
                                                ],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "diagFaceColorSign",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['diagFaceColorSign']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-select", {
                                            ref: "input_diagFaceLustreSign",
                                            attrs: {
                                              code: "diagFaceColorSign",
                                              name: "诊断面部色泽结果",
                                              disabled: false,
                                              "key-field": "key",
                                              "value-field": "value",
                                              options: _vm.toJson(
                                                _vm.jsonStr.faceLustreSign
                                              ),
                                            },
                                            on: {
                                              onFieldChange: _vm.onFieldChange,
                                            },
                                            model: {
                                              value:
                                                _vm.searcher[
                                                  "diagFaceLustreSign"
                                                ],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "diagFaceLustreSign",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['diagFaceLustreSign']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-select", {
                                            ref: "input_diagLipColorSign",
                                            attrs: {
                                              code: "diagLipColorSign",
                                              name: "诊断嘴唇颜色结果",
                                              disabled: false,
                                              "key-field": "key",
                                              "value-field": "value",
                                              options: _vm.toJson(
                                                _vm.jsonStr.lipColorSign
                                              ),
                                            },
                                            on: {
                                              onFieldChange: _vm.onFieldChange,
                                            },
                                            model: {
                                              value:
                                                _vm.searcher[
                                                  "diagLipColorSign"
                                                ],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "diagLipColorSign",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['diagLipColorSign']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-select", {
                                            ref: "input_tongueRecognitionSign",
                                            attrs: {
                                              code: "tongueRecognitionSign",
                                              name: "舌体检测结果",
                                              disabled: false,
                                              "key-field": "key",
                                              "value-field": "value",
                                              options: _vm.toJson(
                                                _vm.jsonStr
                                                  .tongueRecognitionSign
                                              ),
                                            },
                                            on: {
                                              onFieldChange: _vm.onFieldChange,
                                            },
                                            model: {
                                              value:
                                                _vm.searcher[
                                                  "tongueRecognitionSign"
                                                ],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "tongueRecognitionSign",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['tongueRecognitionSign']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-select", {
                                            ref: "input_tongueCrackSign",
                                            attrs: {
                                              code: "tongueCrackSign",
                                              name: "舌裂纹检测结果",
                                              disabled: false,
                                              "key-field": "key",
                                              "value-field": "value",
                                              options: _vm.toJson(
                                                _vm.jsonStr.tongueCrackSign
                                              ),
                                            },
                                            on: {
                                              onFieldChange: _vm.onFieldChange,
                                            },
                                            model: {
                                              value:
                                                _vm.searcher["tongueCrackSign"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "tongueCrackSign",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['tongueCrackSign']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-select", {
                                            ref: "input_tongueFatSign",
                                            attrs: {
                                              code: "tongueFatSign",
                                              name: "舌胖瘦检测结果",
                                              disabled: false,
                                              "key-field": "key",
                                              "value-field": "value",
                                              options: _vm.toJson(
                                                _vm.jsonStr.tongueFatSign
                                              ),
                                            },
                                            on: {
                                              onFieldChange: _vm.onFieldChange,
                                            },
                                            model: {
                                              value:
                                                _vm.searcher["tongueFatSign"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "tongueFatSign",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['tongueFatSign']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-select", {
                                            ref: "input_tongueCoatThickSign",
                                            attrs: {
                                              code: "tongueCoatThickSign",
                                              name: "舌苔厚薄检测结果",
                                              disabled: false,
                                              "key-field": "key",
                                              "value-field": "value",
                                              options: _vm.toJson(
                                                _vm.jsonStr.tongueCoatThickSign
                                              ),
                                            },
                                            on: {
                                              onFieldChange: _vm.onFieldChange,
                                            },
                                            model: {
                                              value:
                                                _vm.searcher[
                                                  "tongueCoatThickSign"
                                                ],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "tongueCoatThickSign",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['tongueCoatThickSign']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-select", {
                                            ref: "input_tongueCoatColorSign",
                                            attrs: {
                                              code: "tongueCoatColorSign",
                                              name: "舌苔颜色检测结果",
                                              disabled: false,
                                              "key-field": "key",
                                              "value-field": "value",
                                              options: _vm.toJson(
                                                _vm.jsonStr.tongueCoatColorSign
                                              ),
                                            },
                                            on: {
                                              onFieldChange: _vm.onFieldChange,
                                            },
                                            model: {
                                              value:
                                                _vm.searcher[
                                                  "tongueCoatColorSign"
                                                ],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "tongueCoatColorSign",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['tongueCoatColorSign']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-select", {
                                            ref: "input_tongueColorSign",
                                            attrs: {
                                              code: "tongueColorSign",
                                              name: "舌质颜色检测结果",
                                              disabled: false,
                                              "key-field": "key",
                                              "value-field": "value",
                                              options: _vm.toJson(
                                                _vm.jsonStr.tongueColorSign
                                              ),
                                            },
                                            on: {
                                              onFieldChange: _vm.onFieldChange,
                                            },
                                            model: {
                                              value:
                                                _vm.searcher["tongueColorSign"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "tongueColorSign",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['tongueColorSign']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-select", {
                                            ref: "input_tongueDiagSign",
                                            attrs: {
                                              code: "tongueDiagSign",
                                              name: "舌诊诊断标注标识",
                                              disabled: false,
                                              "key-field": "key",
                                              "value-field": "value",
                                              options: _vm.toJson(
                                                _vm.jsonStr.faceDiagSign
                                              ),
                                            },
                                            on: {
                                              onFieldChange: _vm.onFieldChange,
                                            },
                                            model: {
                                              value:
                                                _vm.searcher["tongueDiagSign"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "tongueDiagSign",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['tongueDiagSign']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-select", {
                                            ref: "input_diagTongueCrackSign",
                                            attrs: {
                                              code: "diagTongueCrackSign",
                                              name: "诊断舌裂纹检测结果",
                                              disabled: false,
                                              "key-field": "key",
                                              "value-field": "value",
                                              options: _vm.toJson(
                                                _vm.jsonStr.tongueCrackSign
                                              ),
                                            },
                                            on: {
                                              onFieldChange: _vm.onFieldChange,
                                            },
                                            model: {
                                              value:
                                                _vm.searcher[
                                                  "diagTongueCrackSign"
                                                ],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "diagTongueCrackSign",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['diagTongueCrackSign']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-select", {
                                            ref: "input_diagTongueFatSign",
                                            attrs: {
                                              code: "diagTongueFatSign",
                                              name: "诊断舌胖瘦检测结果",
                                              disabled: false,
                                              "key-field": "key",
                                              "value-field": "value",
                                              options: _vm.toJson(
                                                _vm.jsonStr.tongueFatSign
                                              ),
                                            },
                                            on: {
                                              onFieldChange: _vm.onFieldChange,
                                            },
                                            model: {
                                              value:
                                                _vm.searcher[
                                                  "diagTongueFatSign"
                                                ],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "diagTongueFatSign",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['diagTongueFatSign']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-select", {
                                            ref: "input_diagTongueCoatThickSign",
                                            attrs: {
                                              code: "diagTongueCoatThickSign",
                                              name: "诊断舌苔厚薄检测结果",
                                              disabled: false,
                                              "key-field": "key",
                                              "value-field": "value",
                                              options: _vm.toJson(
                                                _vm.jsonStr.tongueCoatThickSign
                                              ),
                                            },
                                            on: {
                                              onFieldChange: _vm.onFieldChange,
                                            },
                                            model: {
                                              value:
                                                _vm.searcher[
                                                  "diagTongueCoatThickSign"
                                                ],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "diagTongueCoatThickSign",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['diagTongueCoatThickSign']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-select", {
                                            ref: "input_diagTongueCoatColorSign",
                                            attrs: {
                                              code: "diagTongueCoatColorSign",
                                              name: "诊断舌苔颜色检测结果",
                                              disabled: false,
                                              "key-field": "key",
                                              "value-field": "value",
                                              options: _vm.toJson(
                                                _vm.jsonStr.tongueCoatColorSign
                                              ),
                                            },
                                            on: {
                                              onFieldChange: _vm.onFieldChange,
                                            },
                                            model: {
                                              value:
                                                _vm.searcher[
                                                  "diagTongueCoatColorSign"
                                                ],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "diagTongueCoatColorSign",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['diagTongueCoatColorSign']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-select", {
                                            ref: "input_tongueColorSign",
                                            attrs: {
                                              code: "tongueColorSign",
                                              name: "诊断舌质颜色检测结果",
                                              disabled: false,
                                              "key-field": "key",
                                              "value-field": "value",
                                              options: _vm.toJson(
                                                _vm.jsonStr.tongueColorSign
                                              ),
                                            },
                                            on: {
                                              onFieldChange: _vm.onFieldChange,
                                            },
                                            model: {
                                              value:
                                                _vm.searcher["tongueColorSign"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "tongueColorSign",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['tongueColorSign']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c("div", { staticClass: "query-class" }, [
                                _c(
                                  "div",
                                  { staticClass: "query-btn-warp" },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "primary",
                                          size: "small",
                                        },
                                        on: { click: _vm.searchBtn },
                                      },
                                      [_vm._v("查询")]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "primary",
                                          size: "small",
                                        },
                                        on: { click: _vm.resetBtn },
                                      },
                                      [_vm._v("重置")]
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm.viewMode == "list"
                ? _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.listLoading,
                          expression: "listLoading",
                        },
                      ],
                      ref: "table",
                      staticClass: "ik-list-table",
                      attrs: {
                        data: _vm.tableData,
                        "element-loading-text": "加载中...",
                        stripe: true,
                        border: true,
                        fit: true,
                        height: "calc(100% - 50px)",
                        "header-row-class-name": "ik-list-table-header-row",
                        "header-cell-class-name": "ik-list-table-header-cell",
                        "row-class-name": "ik-list-table-body-row",
                        "cell-class-name": "ik-list-table-body-cell",
                        "highlight-current-row": true,
                      },
                      on: { "row-click": _vm.rowClick },
                    },
                    [
                      _c("ik-column-text", {
                        attrs: { code: "code", name: "编码", edit: false },
                      }),
                      _c("ik-column-text", {
                        attrs: { code: "name", name: "名称", edit: false },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "userCode",
                          name: "用户编码",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "userName",
                          name: "用户名称",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "robotCode",
                          name: "机器人编码",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "robotName",
                          name: "机器人名称",
                          edit: false,
                        },
                      }),
                      _c("ik-column-select", {
                        attrs: {
                          code: "stateSign",
                          name: "报告状态标识",
                          edit: false,
                          "key-field": "key",
                          "value-field": "value",
                          options: _vm.toJson(_vm.jsonStr.stateSign),
                        },
                      }),
                      _c("ik-column-datetime", {
                        attrs: {
                          code: "diagTime",
                          name: "诊断时间",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "mainPhyCode",
                          name: "主体质编码",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "mainPhyName",
                          name: "主体质名称",
                          edit: false,
                        },
                      }),
                      _c("ik-column-number", {
                        attrs: {
                          code: "mainPhyPct",
                          name: "主体质程度",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "phy1Code",
                          name: "副体质1编码",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "phy1Name",
                          name: "副体质1名称",
                          edit: false,
                        },
                      }),
                      _c("ik-column-number", {
                        attrs: {
                          code: "phyPct1",
                          name: "副体质1程度",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "phy2Code",
                          name: "副体质2编码",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "phy2Name",
                          name: "副体质2名称",
                          edit: false,
                        },
                      }),
                      _c("ik-column-number", {
                        attrs: {
                          code: "phyPct2",
                          name: "副体质2程度",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "phy3Code",
                          name: "副体质3编码",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "phy3Name",
                          name: "副体质3名称",
                          edit: false,
                        },
                      }),
                      _c("ik-column-number", {
                        attrs: {
                          code: "phyPct3",
                          name: "副体质3程度",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "phy4Code",
                          name: "副体质4编码",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "phy4Name",
                          name: "副体质4名称",
                          edit: false,
                        },
                      }),
                      _c("ik-column-number", {
                        attrs: {
                          code: "phyPct4",
                          name: "副体质4程度",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "phy5Code",
                          name: "副体质5编码",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "phy5Name",
                          name: "副体质5名称",
                          edit: false,
                        },
                      }),
                      _c("ik-column-number", {
                        attrs: {
                          code: "phyPct5",
                          name: "副体质5程度",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "phy6Code",
                          name: "副体质6编码",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "phy6Name",
                          name: "副体质6名称",
                          edit: false,
                        },
                      }),
                      _c("ik-column-number", {
                        attrs: {
                          code: "phyPct6",
                          name: "副体质6程度",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "phy7Code",
                          name: "副体质7编码",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "phy7Name",
                          name: "副体质7名称",
                          edit: false,
                        },
                      }),
                      _c("ik-column-number", {
                        attrs: {
                          code: "phyPct7",
                          name: "副体质7程度",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "phy8Code",
                          name: "副体质8编码",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "phy8Name",
                          name: "副体质8名称",
                          edit: false,
                        },
                      }),
                      _c("ik-column-number", {
                        attrs: {
                          code: "phyPct8",
                          name: "副体质8程度",
                          edit: false,
                        },
                      }),
                      _c("ik-column-select", {
                        attrs: {
                          code: "phyDiagSign",
                          name: "体质诊断标注标识",
                          edit: false,
                          "key-field": "key",
                          "value-field": "value",
                          options: _vm.toJson(_vm.jsonStr.phyDiagSign),
                        },
                      }),
                      _c("ik-column-image-oss", {
                        attrs: {
                          code: "faceImg",
                          name: "诊断健康指数",
                          edit: false,
                        },
                      }),
                      _c("ik-column-select", {
                        attrs: {
                          code: "faceRecognitionSign",
                          name: "面部检测结果",
                          edit: false,
                          "key-field": "key",
                          "value-field": "value",
                          options: _vm.toJson(_vm.jsonStr.faceRecognitionSign),
                        },
                      }),
                      _c("ik-column-select", {
                        attrs: {
                          code: "faceColorSign",
                          name: "面部颜色结果",
                          edit: false,
                          "key-field": "key",
                          "value-field": "value",
                          options: _vm.toJson(_vm.jsonStr.faceColorSign),
                        },
                      }),
                      _c("ik-column-select", {
                        attrs: {
                          code: "faceLustreSign",
                          name: "面部色泽结果",
                          edit: false,
                          "key-field": "key",
                          "value-field": "value",
                          options: _vm.toJson(_vm.jsonStr.faceLustreSign),
                        },
                      }),
                      _c("ik-column-select", {
                        attrs: {
                          code: "lipRecognitionSign",
                          name: "嘴唇检测结果",
                          edit: false,
                          "key-field": "key",
                          "value-field": "value",
                          options: _vm.toJson(_vm.jsonStr.lipRecognitionSign),
                        },
                      }),
                      _c("ik-column-select", {
                        attrs: {
                          code: "lipColorSign",
                          name: "嘴唇颜色结果",
                          edit: false,
                          "key-field": "key",
                          "value-field": "value",
                          options: _vm.toJson(_vm.jsonStr.lipColorSign),
                        },
                      }),
                      _c("ik-column-select", {
                        attrs: {
                          code: "faceDiagSign",
                          name: "面诊诊断标注标识",
                          edit: false,
                          "key-field": "key",
                          "value-field": "value",
                          options: _vm.toJson(_vm.jsonStr.lipColorSign),
                        },
                      }),
                      _c("ik-column-select", {
                        attrs: {
                          code: "diagFaceColorSign",
                          name: "诊断面部颜色结果",
                          edit: false,
                          "key-field": "key",
                          "value-field": "value",
                          options: _vm.toJson(_vm.jsonStr.faceColorSign),
                        },
                      }),
                      _c("ik-column-select", {
                        attrs: {
                          code: "diagFaceLustreSign",
                          name: "诊断面部色泽结果",
                          edit: false,
                          "key-field": "key",
                          "value-field": "value",
                          options: _vm.toJson(_vm.jsonStr.faceLustreSign),
                        },
                      }),
                      _c("ik-column-select", {
                        attrs: {
                          code: "diagLipColorSign",
                          name: "诊断嘴唇颜色结果",
                          edit: false,
                          "key-field": "key",
                          "value-field": "value",
                          options: _vm.toJson(_vm.jsonStr.lipColorSign),
                        },
                      }),
                      _c("ik-column-image-oss", {
                        attrs: {
                          code: "tongueImg",
                          name: "舌诊图像",
                          edit: false,
                        },
                      }),
                      _c("ik-column-select", {
                        attrs: {
                          code: "tongueRecognitionSign",
                          name: "舌体检测结果",
                          edit: false,
                          "key-field": "key",
                          "value-field": "value",
                          options: _vm.toJson(
                            _vm.jsonStr.tongueRecognitionSign
                          ),
                        },
                      }),
                      _c("ik-column-select", {
                        attrs: {
                          code: "tongueCrackSign",
                          name: "舌裂纹检测结果",
                          edit: false,
                          "key-field": "key",
                          "value-field": "value",
                          options: _vm.toJson(_vm.jsonStr.tongueCrackSign),
                        },
                      }),
                      _c("ik-column-select", {
                        attrs: {
                          code: "tongueFatSign",
                          name: "舌胖瘦检测结果",
                          edit: false,
                          "key-field": "key",
                          "value-field": "value",
                          options: _vm.toJson(_vm.jsonStr.tongueFatSign),
                        },
                      }),
                      _c("ik-column-select", {
                        attrs: {
                          code: "tongueCoatThickSign",
                          name: "舌胖瘦检测结果",
                          edit: false,
                          "key-field": "key",
                          "value-field": "value",
                          options: _vm.toJson(_vm.jsonStr.tongueCoatThickSign),
                        },
                      }),
                      _c("ik-column-select", {
                        attrs: {
                          code: "tongueCoatColorSign",
                          name: "舌苔颜色检测结果",
                          edit: false,
                          "key-field": "key",
                          "value-field": "value",
                          options: _vm.toJson(_vm.jsonStr.tongueCoatColorSign),
                        },
                      }),
                      _c("ik-column-select", {
                        attrs: {
                          code: "tongueColorSign",
                          name: "舌质颜色检测结果",
                          edit: false,
                          "key-field": "key",
                          "value-field": "value",
                          options: _vm.toJson(_vm.jsonStr.tongueColorSign),
                        },
                      }),
                      _c("ik-column-select", {
                        attrs: {
                          code: "tongueDiagSign",
                          name: "舌诊诊断标注标识",
                          edit: false,
                          "key-field": "key",
                          "value-field": "value",
                          options: _vm.toJson(_vm.jsonStr.faceDiagSign),
                        },
                      }),
                      _c("ik-column-select", {
                        attrs: {
                          code: "diagTongueCrackSign",
                          name: "诊断舌裂纹检测结果",
                          edit: false,
                          "key-field": "key",
                          "value-field": "value",
                          options: _vm.toJson(_vm.jsonStr.tongueCrackSign),
                        },
                      }),
                      _c("ik-column-select", {
                        attrs: {
                          code: "diagTongueFatSign",
                          name: "诊断舌胖瘦检测结果",
                          edit: false,
                          "key-field": "key",
                          "value-field": "value",
                          options: _vm.toJson(_vm.jsonStr.tongueFatSign),
                        },
                      }),
                      _c("ik-column-select", {
                        attrs: {
                          code: "diagTongueCoatThickSign",
                          name: "舌胖瘦检测结果",
                          edit: false,
                          "key-field": "key",
                          "value-field": "value",
                          options: _vm.toJson(_vm.jsonStr.tongueCoatThickSign),
                        },
                      }),
                      _c("ik-column-select", {
                        attrs: {
                          code: "diagTongueCoatColorSign",
                          name: "舌苔颜色检测结果",
                          edit: false,
                          "key-field": "key",
                          "value-field": "value",
                          options: _vm.toJson(_vm.jsonStr.tongueCoatColorSign),
                        },
                      }),
                      _c("ik-column-select", {
                        attrs: {
                          code: "diagTongueColorSign",
                          name: "舌质颜色检测结果",
                          edit: false,
                          "key-field": "key",
                          "value-field": "value",
                          options: _vm.toJson(_vm.jsonStr.tongueColorSign),
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "el-footer",
            { attrs: { height: "40px" } },
            [
              _vm.viewMode == "list"
                ? _c("ik-pagination", {
                    ref: "ik_list_pagination",
                    attrs: {
                      "page-no": _vm.pagination.pageNo,
                      "page-size": _vm.pagination.pageSize,
                      "total-count": _vm.pagination.totalCount,
                    },
                    on: { pageChangeMethod: _vm.pageChange },
                  })
                : _c(
                    "el-row",
                    { staticClass: "ik-list-pagination", attrs: { gutter: 0 } },
                    [
                      _c(
                        "el-col",
                        {
                          staticClass: "ik-list-enterprise-info",
                          attrs: { span: 6, offset: 12 },
                        },
                        [
                          _c("span", { staticStyle: { float: "left" } }, [
                            _vm._v(" 导萃门诊管理系统 "),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
            ],
            1
          ),
        ],
        1
      ),
      _c("Print", {
        ref: "printRef",
        attrs: {
          "print-data": _vm.data.head,
          "scheme-list": _vm.schemeList,
          "scheme-html": _vm.schemeHtml,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }